import { render } from "./ExpenseForm.vue?vue&type=template&id=5513f203"
import script from "./ExpenseForm.vue?vue&type=script&lang=js"
export * from "./ExpenseForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__